import { RSError, RSErrorOptions } from "./RSError";

/**
 * Erreurs liées à la résolution d'adresses (PlaceModel) :
 * description invalide, échec de fetch sans alternative…
 */
export class RSPlaceError<C = Record<string, unknown>> extends RSError<C> {
  constructor(message: string, context?: C, options?: RSErrorOptions) {
    super(message, context, options);
    this.name = "RSPlaceError";
    Object.setPrototypeOf(this, RSPlaceError.prototype);
  }
}
